import { apiServices } from '../services/api.services';
import store from '../store';
import { toast } from 'react-toastify';
import i18n from '../../i18n';

export const setupSelectGuild = (id) => {
  const guilds = store.getState().guilds.guildsList;
  const index = guilds.findIndex((g) => g.id === id);
  const guild = guilds[index];
  var url = "/selectGuild";
  if (guild.selectable === false && guild.selected === false) return;
  if (guild.selected) url = "/unselectGuild";
  const { vip } = store.getState().infos;
  if (!guild.selected && !vip.plan) {
    toast.info(i18n.t('setup:cantSelectDiscord'));
  } else {
    return async (Dispatch) => {
      var args = {id};
      await apiServices.post(url, args).then((res) => {
        if (res.data && res.data.success) {
          Dispatch({type: 'SETUP_SELECT_GUILD', id: id});
        } else {
          toast.error(i18n.t('setup:errorSelect', {step: i18n.t(`setup.${guild.selected ? 'unselected' : 'selected'}`)}));
        }
      }).catch(err => {
          return err;
      });
    };
  }
};

export const deleteServer = (id) => {
  if (!id) return;
  return async (Dispatch) => {
    apiServices.post("/deleteServer", {id}).then((res) => {
      if (res.data && res.data.success) {
        Dispatch({type: 'SETUP_DELETE_SERVER', id});
        toast.success(i18n.t('setup:deletedSuccess'));
      } else {
        toast.error(i18n.t('setup:deletedError'));
      }
    }).catch(err => {
        return err;
    });
  };
};

export const setListener = (state) => {
  return async (Dispatch) => {
    apiServices.post("/setListener", {state}).then((res) => {
      if (res.data && res.data.success) {
        Dispatch({type: 'INFOS_SET_LISTENER', state});
      }
    }).catch(err => {
        return err;
    });
  };
};

export const setupSelectServer = (server) => {
  const servers = store.getState().servers;
  var checkUnselect = false;
  if(server === servers.selectedServer) checkUnselect = true;
  if (checkUnselect) {
    return async (Dispatch) => {
      apiServices.post("/unselectServer").then((res) => {
        if (res && res.data && res.data.success) {
          Dispatch({type: 'SETUP_UNSELECT_SERVER', server});
        }
      }).catch(err => {
          return err;
      });
    };
  }
  else {
    const { vip } = store.getState().infos;
    if (!vip.plan) return toast.info(i18n.t('setup:cantSelectRustServer'));
    return async (Dispatch) => {
      const args = {id: server};
      await apiServices.post("/selectServer", args).then((res) => {
        if (res && res.data && res.data.success) {
          Dispatch({type: 'SETUP_SELECT_SERVER', server});
          Dispatch({type: 'RESET_MAP'});
          apiServices.get("/devices").then((res) => {
            if (res && res.data && res.data.success) {
              Dispatch({type: 'SET_DEVICES', devices: res.data});
            }
          }).catch(err => {
              return err;
          });
        }
      }).catch(err => {
          return err;
      });
    };
  }
};

export const refreshGuilds = () => {
    apiServices.post("/refreshGuilds")
      .then(res => {
        if (res && res.data && res.data.success) return toast.success(i18n.t('setup:guildRefreshed'));
        else return toast.error(i18n.t('setup:guildRefreshError'));
      })
      .catch(err => {
        toast.error(i18n.t('setup:guildRefreshError'));
        return err;
    });
}